module.exports = {"title":"Contact","desc":"Page de contact de la maison d'édition ISBA"}